import { type ReactNode, useReducer } from 'react';

import { env } from '@/config/env';
import { logger } from '@/lib/logger';

import { selectViewState } from './selectors';
import { SessionDispatchContext, SessionStateContext } from './sessionContext';
import { initialSessionState, sessionReducer } from './sessionReducer';
import { type Action, type SessionState } from './types';

function loggedReducer(state: SessionState, action: Action): SessionState {
  const next = sessionReducer(state, action);
  if (env.enableDevTools && next !== state) {
    const from = selectViewState(state);
    const to = selectViewState(next);
    if (from !== to) {
      logger.debug('[state] view', { from, to, cause: action.type });
    }
  }
  return next;
}

export function SessionProvider({
  children,
  initialState = initialSessionState,
}: {
  children: ReactNode;
  initialState?: SessionState | undefined;
}) {
  const [state, dispatch] = useReducer(loggedReducer, initialState);
  return (
    <SessionDispatchContext.Provider value={dispatch}>
      <SessionStateContext.Provider value={state}>{children}</SessionStateContext.Provider>
    </SessionDispatchContext.Provider>
  );
}
